import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class HightScoreTab extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.y = GameConstants.GAME_HEIGHT;

        const background = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "high_score_tab");
        background.setOrigin(.5, 1);
        this.add(background);

        const bestTimeLabelText = new Phaser.GameObjects.Text(
            scene, -54, -35, 
            gameText.BEST_TIME[lan], 
            { fontFamily: "OpenSans-CondLight", fontSize: "26px", color: "#877759" }
        );
        this.add(bestTimeLabelText);

        if (bestTimeLabelText.width > 100) {
            bestTimeLabelText.setScale(100 / bestTimeLabelText.width);
        }

        // Número del tiempo
        const bestTimeValueText = new Phaser.GameObjects.Text(
            scene, bestTimeLabelText.width * bestTimeLabelText.scale - 48, -36, 
            GameVars.formatTime(GameVars.bestTime), 
            { fontFamily: "Arial", fontSize: "29px", color: "#877759", fontStyle: "bold" }
        );
        bestTimeValueText.scaleX = .8;
        this.add(bestTimeValueText); 

        this.visible = false;
    }

    public startGame(): void {

        this.visible = true;

        if (!GameVars.levelReset) {     

            this.y = GameConstants.GAME_HEIGHT + 100;

            this.scene.tweens.add({
                targets: this,
                y: GameConstants.GAME_HEIGHT,
                duration: 1000,
                delay: 3000,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }

    public onGamePausedResumed(): void {

        if (GameVars.paused) {

            this.scene.tweens.add({
                targets: this,
                y: GameConstants.GAME_HEIGHT + 100,
                duration: 450,
                ease: Phaser.Math.Easing.Cubic.Out
            });

        } else {

            this.scene.tweens.add({
                targets: this,
                y: GameConstants.GAME_HEIGHT,
                duration: 450,
                ease: Phaser.Math.Easing.Cubic.Out
            });
        }
    }
}
